/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";
import * as THREE from "three";

export function Packaging(props) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF(
    "/Deleito_Web_HOME_PackagingHero_v08.glb"
  );
  const { actions } = useAnimations(animations, group);

  const handleClick = () => {
    const rigging = actions?.["Armature.003Action"];
    const movement = actions?.["Empty.001Action"];

    const playAction = (action) => {
      action.paused = false;
      action.timeScale = props.isClosed ? 1 : -1;
      action.setLoop(THREE.LoopOnce).clampWhenFinished = true;
      action.play();
    };

    if (rigging && !rigging.isRunning() && movement && !movement.isRunning()) {
      playAction(rigging);
      playAction(movement);
    }
    props.setIsClosed(!props.isClosed);
  };

  return (
    <group ref={group} rotation={[-Math.PI / 9, 0, 0]} {...props}>
      <group name="Scene" onClick={handleClick}>
        <group
          name="Empty001"
          position={[0.007, 0, 0.624]}
          rotation={[Math.PI / 2, 0, Math.PI]}
          scale={1.303}
        >
          <group name="Armature004" position={[-0.005, 2.314, 0]} scale={0.767}>
            <group name="Plane011">
              <skinnedMesh
                name="Plane015"
                geometry={nodes.Plane015.geometry}
                material={materials["Caja Blanca 01"]}
                skeleton={nodes.Plane015.skeleton}
              />
              <skinnedMesh
                name="Plane015_1"
                geometry={nodes.Plane015_1.geometry}
                material={materials.Interno}
                skeleton={nodes.Plane015_1.skeleton}
              />
            </group>
            <primitive object={nodes.Bone004} />
            <primitive object={nodes.Bone005} />
            <primitive object={nodes.Bone006} />
            <primitive object={nodes.Bone007} />
          </group>
          <mesh
            name="packing001"
            castShadow
            receiveShadow
            geometry={nodes.packing001.geometry}
            material={materials.Burger}
            position={[-0.014, 0.016, -0.412]}
            rotation={[0, 0, 3.046]}
            scale={0.007}
          />
        </group>
      </group>
    </group>
  );
}

useGLTF.preload("/Deleito_Web_HOME_PackagingHero_v08.glb");
